var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-area-selector" }, [
    _c(
      "div",
      { staticClass: "yxtbiz-area-selector__left" },
      [
        _c("AreaTree", {
          attrs: { list: _vm.value },
          on: {
            "update:list": function ($event) {
              _vm.value = $event
            },
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "yxtbiz-area-selector__right" },
      [
        _c("CheckedAreas", {
          attrs: { list: _vm.value, limit: _vm.limit },
          on: {
            "update:list": function ($event) {
              _vm.value = $event
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }